module.exports = __webpack_public_path__ + "static/media/chat.756d47a6.svg";